import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Calendar, TimeInput } from 'react-widgets';
import Localization from 'react-widgets/Localization';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import classnames from 'classnames';

import { formatDatetime } from '../../helpers/timezone';
import { useOutsideClick } from '../../helpers/clickOutside';
import { ReactComponent as MenuButtonSVG } from '../../icons/table/menu-button.svg';
import { ReactComponent as QuestionMarkSVG } from '../../icons/question-mark.svg';

const local = {
  label: 'French',
  culture: 'fr',
  firstOfWeek: 1,
};

const TableCellDatetimePick = ({
  pickupDate: p,
  deliveryDate: d,
  onDateUpdate,
  readOnly,
}) => {
  const menuRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [pickupDate, setPickupDate] = useState(p);
  const [deliveryDate, setDeliveryDate] = useState(d);

  useOutsideClick(menuRef, () => setShowDropdown(false));
  const datetimeClasses = classnames('th-list-data', {
    pointer: !readOnly,
  });

  return (
    <div className={datetimeClasses} id="th-cell-header" ref={menuRef}>
      <div
        className="flex items-center justify-between"
        onClick={readOnly ? () => {} : () => setShowDropdown(!showDropdown)}
      >
        <div>
          <h3 className="ma0 pa0 th-members-list-name ">Delivery date</h3>
          {d ? (
            <p className="apps-card-app-desc">{formatDatetime(d)}</p>
          ) : (
            <p className="apps-card-app-desc">Not set</p>
          )}
          <h3 className="ma0 pa0 th-members-list-name">Pickup date</h3>
          {p ? (
            <p className="apps-card-app-desc">{formatDatetime(p)}</p>
          ) : (
            <p className="apps-card-app-desc">Not set</p>
          )}
        </div>
        {!readOnly && <MenuButtonSVG />}
      </div>

      {showDropdown && (
        <div
          className="th-select-filter-dropdown"
          style={{
            width: '720px',
            marginTop:
              document.getElementById('th-cell-header').offsetHeight - 91,
          }}
        >
          <div className="pr5 pl5 flex justify-between ">
            <div className="mt2 flex flex-column items-center">
              <h3 className="flex items-center pa0 th-members-list-name">
                Delivery date
                <QuestionMarkSVG data-rh="All time in the web app is in CET." />
              </h3>
              <Localization date={new DateLocalizer(local)}>
                <Calendar
                  bordered={false}
                  value={deliveryDate}
                  onChange={(value) => setDeliveryDate(value)}
                />
                <TimeInput
                  style={{ width: 'auto' }}
                  datePart={deliveryDate}
                  value={deliveryDate}
                  onChange={(value) => setDeliveryDate(value)}
                />
              </Localization>
            </div>
            <div style={{ margin: '10px' }}></div>
            <div className="mt2 flex flex-column items-center">
              <h3 className="flex items-center pa0 th-members-list-name">
                Pickup date
                <QuestionMarkSVG data-rh="All time in the web app is in CET." />
              </h3>
              <Localization date={new DateLocalizer(local)}>
                <Calendar
                  bordered={false}
                  value={pickupDate}
                  onChange={(value) => setPickupDate(value)}
                />
                <TimeInput
                  style={{ width: 'auto' }}
                  datePart={pickupDate}
                  value={pickupDate}
                  onChange={(value) => setPickupDate(value)}
                />
              </Localization>
            </div>
          </div>
          <div className="tc mb2">
            <button
              className="btn-whitegrey mr4"
              onClick={() => {
                onDateUpdate({ pickupDate: null, deliveryDate: null });
                setShowDropdown(false);
              }}
            >
              <span>Reset</span>
            </button>
            <button
              className="btn-green"
              onClick={() => {
                onDateUpdate({ pickupDate, deliveryDate });
                setShowDropdown(false);
              }}
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

TableCellDatetimePick.propTypes = {
  pickupDate: PropTypes.instanceOf(Date),
  deliveryDate: PropTypes.instanceOf(Date),
  onDateUpdate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default TableCellDatetimePick;
